import { PayslipTypes } from '@app/entities/enums/ptrab/payslip-types.enum';
import { Company } from '@app/entities/models/ptrab/shared/company.model';

export class Payslip {
  id!: string;
  company!: Company;
  isBonus!: boolean;
  startDate!: string;
  endDate!: string;
  type?: PayslipTypes;
}
